import PozplanView from './PozplanView';
export default PozplanView;